<template>
  <div class="action-bar">
    <button
      @click="debounceSearch"
      class="search-btn flex justify-center items-center text-white w-full"
    >
      <Icon name="search_solid" width="13" height="13" class="mr-2" />
      <span>検索</span>
    </button>

    <!-- CRM汎用独自対応↓↓↓ -->
    <!-- <button
      @click="showPopupFilter"
      class="filter-btn flex justify-center items-center w-full"
    >
      <img
        src="~@/assets/icons/line-filter-icon.svg"
        alt="demo"
        class="mr-2"
      />
      <span>条件で絞り込み</span>
    </button> -->
    <!-- CRM汎用独自対応↑↑↑ -->
  </div>
</template>

<script>
export default {
  methods: {
    debounceSearch() {
      this.$emit('search');
    },
    showPopupFilter() {
      this.$emit('filter');
    }
  }
}
</script>
<style lang="scss" scoped>
@import './styles.scss';
</style>